"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable consistent-return */
const react_1 = __importStar(require("react"));
const className_1 = require("../../../utils/className");
const Toast = ({ message, className, removeToast, timer }) => {
    const [exit, setExit] = react_1.useState(false);
    react_1.useEffect(() => {
        if (!exit) {
            const timerTimeout = setTimeout(() => {
                setExit(true);
                setTimeout(() => removeToast(message.id), 1000);
            }, timer);
            return () => clearTimeout(timerTimeout);
        }
    }, [exit]);
    const removeWhenClick = react_1.useCallback(() => {
        setExit(true);
        setTimeout(() => removeToast(message.id), 1000);
    }, []);
    return (react_1.default.createElement("div", { className: className_1.mapToCssModules([
            'vbz-custom-toast',
            className,
            message.description ? 'hasdescription' : '0',
            exit ? 'hidden' : '',
        ]), onClick: removeWhenClick },
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, message.description)),
        react_1.default.createElement("i", { className: "material-icons" }, "check")));
};
exports.default = react_1.memo(Toast);
//# sourceMappingURL=index.js.map